const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withBundleLoading = require("../../core/hoc/withBundleLoading");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const {atCart, atParentAccount} = require("../../core/vault/StateCursors");
const URLMake = require("../../../shared/URLMake");
const OpsUser = require("../../core/vault/OpsUser");
const OpsCart = require("../vault/OpsCart");
const AT = require("../../core/vault/ActionTypes");
const LoadGuard = require("../../core/view/LoadGuard");
const InitRenderSwitch = require("../../core/view/InitRenderSwitch");
const LoadingCircle = require("../../core/view/LoadingCircle");
const ReviewCart = require("./ReviewCart");
const ReviewClassWalletCart = require("./ReviewClassWalletCart");
const ReviewClassWalletOrder = require("./ReviewClassWalletOrder");
const CompleteOrder = require("./CompleteOrder");
const ConfirmSubmission = require("./ConfirmSubmission");
const CreateAccount = require("./CreateAccount");
const ShippingInfo = require("./ShippingInfo");
const PayPalInfo = require("./PayPalInfo");
const BillingInfo = require("./BillingInfo");
const CopyTable = require("../data/CopyTable");
const CheckoutSteps = require("../CheckoutSteps");
const {PortalDestination} = require("../../core/view/PortalDestination");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const styles = require("./styles/PageCheckout.css");
const {setupCheckoutShortcut} = require("../vault/OpsCheckoutForm");
const {track} = require("../../core/util/Mixpanel");

const checkoutErrorCopy = CopyTable.getCheckoutErrorCopy();

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withBundleLoading(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		cart: atCart(vaultState).get(),
		account: atParentAccount(vaultState).get(),
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageCheckout",

		propTypes: {
			user: PT.object.isRequired,
			step: PT.string.isRequired,
			setNextScrollTo: PT.func.isRequired,

			// Injected by HOCs
			cart: PT.object.isRequired,
			account: PT.object,
			dispatch: PT.func.isRequired,
			requireOrLoadBundle: PT.func.isRequired,
		},

		componentDidMount: function() {
			this.teardownShortcut = setupCheckoutShortcut(
				this.props.cart.form,
				this.props.dispatch
			);
		},

		componentWillUnmount: function() {
			this.teardownShortcut?.();
		},

		// Used by vault update HOC
		vaultEvents: {
			// TODO: any others to bring over from ErrorModal.jsx?
			checkoutFieldsError: function(step, fields) {
				// TODO: copied from ErrorModal, but long enough we might want to share it
				if (step === "billing") {
					if (fields && fields.creditCard) {
						const field = fields.creditCard[0];
						if (field === "number") {
							this.showError("cardInvalid");
						} else if (field === "exp") {
							this.showError("cardInvalidExp");
						} else {
							this.showError("billingFieldError");
						}
					} else {
						this.showError("billingFieldError");
					}
				} else if (step === "shipping") {
					this.showError("shippingFieldError");
				}
			},
			cvvMismatch: function() {
				this.showError("cvvMismatch");
			},
			cardTypeNotSupported: function() {
				this.showError("cardTypeNotSupported");
			},
			captchaUnanswered: function() {
				this.showError("captchaUnanswered");
			},
			placeOrderUnknown: function() {
				this.showError("placeOrderUnknown");
			},
		},

		getInitialState: function() {
			return {
				topErrorText: "",
			};
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			// TODO: Maybe there are cart changes that should clear this?
			if (this.props.step !== nextProps.step) {
				this.props.setNextScrollTo("top");
				this.setState({topErrorText: ""});
			}
		},

		showError: function(errorType) {
			const errorText =
				checkoutErrorCopy[errorType] || checkoutErrorCopy.default;
			this.setState({topErrorText: errorText});
		},

		setSection: function(newSection) {
			track(`Checkout Step Changed: ${this.props.step} → ${newSection}`, {
				previousStep: this.props.step,
				newStep: newSection,
			});
			if (newSection !== this.props.step) {
				this.props.dispatch({
					type: AT.SET_PAGE,
					pageState: URLMake.state.forCheckoutStep(newSection),
					addToHistory: true,
				});
			}
		},

		nextSection: function() {
			const cart = this.props.cart;
			const steps = OpsCart.getAllCheckoutSteps(cart).concat(["confirm"]);

			const currIndex = steps.indexOf(this.props.step);
			if (
				currIndex < steps.length - 1 &&
				currIndex > -1 &&
				!OpsCart.isEmpty(cart)
			) {
				this.setSection(steps[currIndex + 1]);
			}
		},

		renderSteps: function() {
			const {cart, user, step} = this.props;
			const steps = OpsCart.getAllCheckoutSteps(cart);
			const availableSteps = OpsCart.getAvailableCheckoutSteps(
				cart,
				user,
				step
			);
			const stepLabels = steps.map(s => (s === "paypalinfo" ? "info" : s));

			return (
				<CheckoutSteps
					steps={steps}
					stepLabels={stepLabels}
					availableSteps={availableSteps}
					currentStep={step}
					onChangeStep={this.setSection}
				/>
			);
		},

		loadParentAccount: function() {
			this.props.dispatch({
				type: AT.LOAD_PARENT_ACCOUNT_REQUEST,
			});
		},

		render: function() {
			const {cart, user, step, account} = this.props;
			const {isClassWalletFlow = false} = cart;
			const sectionEls = {
				cart: isClassWalletFlow ? ReviewClassWalletCart : ReviewCart,
				account: CreateAccount,
				shipping: ShippingInfo,
				billing: BillingInfo,
				paypalinfo: PayPalInfo,
				review: isClassWalletFlow ? ReviewClassWalletOrder : CompleteOrder,
				confirm: ConfirmSubmission,
			};

			const MainType = sectionEls[step];

			const content = (
				<MainType
					cart={cart}
					user={user}
					setSection={this.setSection}
					onContinue={this.nextSection}
					step={step}
				/>
			);

			let mainDiv;

			if (step === "confirm") {
				mainDiv = content;
			} else {
				let topError = null;

				if (this.state.topErrorText) {
					topError = (
						<div className={styles.topError}>{this.state.topErrorText}</div>
					);
				}

				let parentLoad = null;
				if (OpsUser.hasParentRole(user) && account) {
					parentLoad = (
						<LoadGuard
							identifier={"parentAccountSubs"}
							status={account}
							requestLoad={this.loadParentAccount}
							loadingView={"logo"}
							errorView={"refreshOffice"}
							renderLoaded={() => {}}
						/>
					);
				} else if (OpsUser.hasParentRole(user)) {
					// This will set up the "account" field in the vault.
					this.props.requireOrLoadBundle("parent");
				}

				// If we block shipping, check for it here and pass in a boolean to
				// getShippingNotice in the second arg and update the function in
				// CopyTable accordingly.
				const shippingNotice = OpsCart.needsShipping(cart)
					? CopyTable.getShippingNotice(
							styles,
							OpsCart.needsShippingToBlockedAddress(cart)
					  )
					: null;

				mainDiv = (
					<div className={styles.main}>
						<div className={styles.mainContent}>
							{this.renderSteps()}
							{shippingNotice}
							{topError}
							{content}
							{parentLoad}
							<PortalDestination
								className={styles.modal}
								name={PORTAL_CONTAINERS.CHECKOUT}
							/>
						</div>
					</div>
				);
			}

			const initialLoadingDiv = (
				<div className={styles.mainLoading}>
					<div className={styles.loadingContainer}>
						<LoadingCircle />
					</div>
				</div>
			);

			return (
				<InitRenderSwitch forFirstRender={initialLoadingDiv}>
					{mainDiv}
				</InitRenderSwitch>
			);
		},
	})
);
